import client from '../client';

export const EDIT_SETTINGS = 'EDIT_SETTINGS';
export const FETCH_SETTINGS = 'FETCH_SETTINGS';

export function editSettings(data) {
  return {
    type: EDIT_SETTINGS,
    promise: client.put('admin/settings', data),
  };
}

export function fetchSettings() {
  return {
    type: FETCH_SETTINGS,
    promise: client.get('admin/settings'),
  };
}



// WEBPACK FOOTER //
// ./src/settings/actions.js